import { memo } from "react";

import BaseNumericInput from "./BaseNumericInput";

function NumberInput(props) {
  return (
    <BaseNumericInput
      {...props}
      inputMode="numeric"
      formatter={(value) => {
        if (
          value === "" ||
          value === null ||
          value === undefined
        ) {
          return "";
        }

        return Number(value).toLocaleString("en-IN");
      }}
      parser={(value) => {
        if (value === "") return "";

        return Number(
          String(value).replace(/,/g, "")
        );
      }}
    />
  );
}

export default memo(NumberInput);